export default "__VITE_ASSET__dhS4HSbd__"